import * as React from 'react'

import { pathOverrideConfig } from 'configuration/bloomreach'

import { withErrorPage, withScridId } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'

import { withCms, withLayout } from '../../cms'
import { defaultErrorProps } from '../error-props'
import { withCart } from './with-cart'

export function composePDP<T>(PDP: React.FunctionComponent<T>) {
  return compose<T, T>(
    withCms(pathOverrideConfig),
    withErrorPage(defaultErrorProps),
    withLayout(),
    withCart({ isReadOnly: true }),
    withScridId()
  )(PDP)
}
